import Pin2SVG from "../../../svgs/Pin2SVG";

type PinProp = {
  className: string;
};
const Pin = ({ className }: PinProp) => {
  return (
    <span
      className={`absolute w-[20px] h-[20px] flex justify-center items-center lg:scale-[200%] ${className}`}
    >
      <Pin2SVG />
    </span>
  );
};

export default Pin;
